
import {
    Component,
    ComponentFactoryResolver,
    OnInit,
    ViewChild,
    ViewContainerRef,
    ViewEncapsulation,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ScriptLoaderService } from '../_services/script-loader.service';
import { AuthenticationService } from './_services/authentication.service';
import { AlertService } from './_services/alert.service';
import { UserService } from './_services/user.service';
import { AlertComponent } from './_directives/alert.component';
import { LoginCustom } from './_helpers/login-custom';
import { Helpers } from '../helpers';
import { SelectItem } from 'primeng/components/common/api';
import { Utils } from '../utils';

@Component({
    selector: '.m-grid.m-grid--hor.m-grid--root.m-page',
    templateUrl: './templates/login-1.component.html',
    encapsulation: ViewEncapsulation.None,
})

export class AuthComponent implements OnInit {
    model: any = {};
    loading = false;
    returnUrl: string;
    selectedTypes: string[] = ['PayPal', 'MasterCard'];
    types: SelectItem[];
    @ViewChild('alertSignin',
        { read: ViewContainerRef }) alertSignin: ViewContainerRef;
    @ViewChild('alertSignup',
        { read: ViewContainerRef }) alertSignup: ViewContainerRef;
    @ViewChild('alertForgotPass',
        { read: ViewContainerRef }) alertForgotPass: ViewContainerRef;

    constructor(
        private _router: Router,
        private _script: ScriptLoaderService,
        private _userService: UserService,
        private _route: ActivatedRoute,
        private _authService: AuthenticationService,
        private _alertService: AlertService,
        private cfr: ComponentFactoryResolver) {
        this.types = [
            { label: 'Consulente', value: 'Consultant' },
            { label: 'Azienda', value: 'Company' }
        ];
    }

    ngOnInit() {
        this.model.remember = true;
        // get return url from route parameters or default to '/'
        this.returnUrl = this._route.snapshot.queryParams['returnUrl'] || '/';
        this._router.navigate([this.returnUrl]);

        this._script.loadScripts('body', [
            'assets/vendors/base/vendors.bundle.js',
            'assets/demo/default/base/scripts.bundle.js'], true).then(() => {
                Helpers.setLoading(false);
                LoginCustom.init();
            });
    }

    signin() {
        this.loading = true;
        let that = this;
        this._authService.login(this.model.email, this.model.password)
            .subscribe(
            data => {
                Utils.log("login ok", data, this.returnUrl);
                that._router.navigate([this.returnUrl]);

                //alert("RETURN_URL: "+this.returnUrl);

                that.loading = false;
            },
            error => {
                Utils.log("login error", error);
                that.showAlert('alertSignin');
                let err = JSON.parse(error._body)
                if (err.response == 17) {
                    that._alertService.error("Utente non attivo, verificare la mail e confermare l'utenza");
                } else
                    this._alertService.error(err.errors);
                that.loading = false;
            });
    }

    signup() {
        this.loading = true;
        this._userService.create(this.model)
            .subscribe(
            data => {

                if (data.response == 0) {

                    this.showAlert('alertSignin');
                    this._alertService.success('Grazie. Per completare la registrazione contralla la casella mail.', true);
                    LoginCustom.displaySignInForm();
                    this.model = {};
                } else if (data.response == 7) {

                    this.showAlert('alertSignup');
                    this._alertService.error('Utente già esistente');

                }

                else {

                    this.showAlert('alertSignup');
                    this._alertService.error(data.errors);

                }
                this.loading = false;


            },
            error => {
                this.showAlert('alertSignup');
                this._alertService.error(error);
                this.loading = false;
            });
    }

    forgotPass() {
        this.loading = true;
        this._userService.forgotPassword(this.model.email).subscribe(
            data => {
                this.showAlert('alertSignin');
                this._alertService.success(
                    'Cool! Password recovery instruction has been sent to your email.',
                    true);
                this.loading = false;
                LoginCustom.displaySignInForm();
                this.model = {};
            },
            error => {
                this.showAlert('alertForgotPass');
                this._alertService.error(error);
                this.loading = false;
            });
    }

    showAlert(target) {
        this[target].clear();
        let factory = this.cfr.resolveComponentFactory(AlertComponent);
        let ref = this[target].createComponent(factory);
        ref.changeDetectorRef.detectChanges();
    }
}


// WEBPACK FOOTER //
// ./src/app/auth/auth.component.ts